import { useEffect, useRef } from 'react';
import { ROLES } from '../core/constants/roles';
import { buildPlayWinNotification } from '../core/notifications/playWinMessages';
import type { PlayLike } from '../core/rules/numberCaps';

interface UsePlayWinNotificationsOptions {
  role: string;
  lang: string;
  plays: PlayLike[];
  viewerId?: string;
  push: (fields: Record<string, unknown>, source?: string) => void;
}

/** Notifies listers only when a play is actually settled as won. */
export function usePlayWinNotifications({
  role,
  lang,
  plays,
  viewerId,
  push,
}: UsePlayWinNotificationsOptions) {
  const knownStatusRef = useRef(new Map<string, string>());

  useEffect(() => {
    if (role !== ROLES.LISTER || !viewerId) return;

    for (const play of plays) {
      if (!play.id || play.listerId !== viewerId) continue;

      const prev = knownStatusRef.current.get(play.id);
      const next = String(play.status ?? 'open');
      knownStatusRef.current.set(play.id, next);

      if (prev === undefined) continue;
      if (prev === next || next !== 'won') continue;

      push(buildPlayWinNotification(play, lang), 'scheduler');
    }
  }, [role, lang, plays, viewerId, push]);
}
